<template>
    <v-dialog v-model="dialog" max-width="800px" persistent>
        <v-card>
            <v-card-title class="bg-primary text-white d-flex align-center py-3">
                <v-icon left class="mr-2">mdi-account-details</v-icon>
                <span class="text-h6">{{ isEdit ? 'Modifica Cliente' : 'Nuovo Cliente' }}</span>
                <v-spacer></v-spacer>
                <v-btn icon="mdi-close" variant="text" color="white" @click="chiudi"></v-btn>
            </v-card-title>

            <v-card-text class="pt-4">
                <v-form ref="form" v-model="valid">
                    <v-row dense>
                        <v-col cols="12" md="12">
                            <v-text-field v-model="cliente.ragioneSociale" label="Ragione Sociale" variant="outlined"
                                density="compact" />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="cliente.nome" label="Nome Referente" variant="outlined"
                                density="compact" />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="cliente.cognome" label="Cognome Referente" variant="outlined"
                                density="compact" />
                        </v-col>

                        <v-col cols="12">
                            <v-divider class="my-2" />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field v-model="cliente.pIva" label="Partita IVA" variant="outlined"
                                density="compact" maxlength="11" counter />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="cliente.codiceFiscale" label="Codice Fiscale" variant="outlined"
                                density="compact" />
                        </v-col>

                        <v-col cols="12" md="8">
                            <v-text-field v-model="cliente.indirizzo" label="Indirizzo (Via)" variant="outlined"
                                density="compact" />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="cliente.cap" label="CAP" variant="outlined" density="compact" />
                        </v-col>
                        <v-col cols="12" md="5">
                            <v-text-field v-model="cliente.localita" label="Località (Città)" variant="outlined"
                                density="compact" />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-text-field v-model="cliente.provincia" label="Provincia (Sigla)" variant="outlined"
                                density="compact" maxlength="2" />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="cliente.stato" label="Stato/Nazione" variant="outlined"
                                density="compact" />
                        </v-col>

                        <v-col cols="12">
                            <v-divider class="my-2" />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field v-model="cliente.email" label="Email" type="email" variant="outlined"
                                density="compact" />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="cliente.pec" label="PEC" type="email" variant="outlined"
                                density="compact" />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="cliente.codiceUnivoco" label="Cod. Univoco (SDI)" variant="outlined"
                                density="compact" />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="cliente.telefono" label="Telefono Fisso" variant="outlined"
                                density="compact" />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="cliente.cellulare" label="Cellulare" variant="outlined"
                                density="compact" />
                        </v-col>

                        <v-col cols="12">
                            <v-textarea v-model="cliente.note" label="Note (Interne)" variant="outlined" rows="2" />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>

            <v-card-actions class="px-4 pb-4">
                <v-spacer></v-spacer>
                <v-btn color="grey-darken-1" variant="text" @click="chiudi" :disabled="loading">Annulla</v-btn>
                <v-btn color="primary" variant="flat" @click="salva" :loading="loading">Salva Cliente</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { salvaCliente } from "@/api/api.clienti.js";

export default {
    emits: ["salvato"],
    data() {
        return {
            dialog: false,
            valid: false,
            loading: false,
            isEdit: false,
            cliente: this.getEmptyCliente()
        };
    },
    methods: {
        getEmptyCliente() {
            return { clienteID: 0, ragioneSociale: "", nome: "", cognome: "", pIva: "", codiceFiscale: "", indirizzo: "", localita: "", provincia: "", cap: "", stato: "Italia", telefono: "", cellulare: "", email: "", pec: "", codiceUnivoco: "", note: "" };
        },
        apri(clienteToLoad = null) {
            if (clienteToLoad) {
                this.cliente = { ...clienteToLoad };
                // Se c'è un ID maggiore di 0 significa che stiamo modificando.
                // Se viene da "Duplica" o "Salva da Ordine", clienteID sarà forzatamente = 0 e quindi isEdit sarà false.
                this.isEdit = this.cliente.clienteID > 0;
            } else {
                this.cliente = this.getEmptyCliente();
                this.isEdit = false;
            }
            this.dialog = true;
            if (this.$refs.form) this.$refs.form.resetValidation();
        },
        chiudi() {
            this.dialog = false;
        },
        async salva() {
            // Validazione basica: deve esserci almeno una Ragione Sociale o un Cognome
            if (!this.cliente.ragioneSociale && !this.cliente.cognome) {
                this.$store.commit("app/showMessage", { testo: "Inserisci almeno la Ragione Sociale o il Cognome.", tipo: "error" });
                return;
            }
            this.loading = true;
            try {
                const res = await salvaCliente(this.cliente);
                this.$store.commit("app/showMessage", { testo: "Cliente salvato con successo!", tipo: "success" });
                this.cliente.clienteID = this.cliente.clienteID || res.data.clienteID;
                this.$emit("salvato", this.cliente); // Emette l'evento per aggiornare liste esterne
                this.chiudi();
            } catch (e) {
                // Errore gestito dall'interceptor
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>